document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('SearchToggle');
  const overlay = document.getElementById('SearchOverlay');
  const closeBtn = document.getElementById('SearchClose');
  const input = document.getElementById('SearchInput');
  const results = document.getElementById('SearchResults');

  if (!toggle || !overlay || !input) return;

  let debounceTimer;

  function openSearch() {
    overlay.classList.add('is-active');
    setTimeout(() => input.focus(), 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-active');
    results.innerHTML = '';
  }

  toggle.addEventListener('click', openSearch);
  closeBtn.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  input.addEventListener('input', function () {
    const query = input.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(function () {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor`)
        .then((res) => res.json())
        .then((data) => {
          const products = data.resources.results.products;
          renderResults(products, query);
        })
        .catch(() => {
          results.innerHTML = '';
        });
    }, 250);
  });

  function renderResults(products, query) {
    if (products.length) {
      overlay.classList.add('has-results');
    } else {
      overlay.classList.remove('has-results');
    }

    if (!products.length) {
      results.innerHTML = `<div class="search-empty">No results for "${escapeHtml(query)}"</div>`;
      return;
    }

    results.innerHTML = products.map((product) => `
      <a href="${product.url}" class="search-result">
        <div class="search-result-image">
          ${product.image ? `<img src="${product.image}" alt="${escapeHtml(product.title)}">` : ''}
        </div>
        <div class="search-result-info">
          <div class="search-result-title">${escapeHtml(product.title)}</div>
          <div class="search-result-price">${product.price}</div>
        </div>
      </a>
    `).join('');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
});